import { render, staticRenderFns } from "./ProdutoForm.vue?vue&type=template&id=7809497b&"
import script from "./ProdutoForm.vue?vue&type=script&lang=js&"
export * from "./ProdutoForm.vue?vue&type=script&lang=js&"
import style0 from "./ProdutoForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports